module.exports = __webpack_public_path__ + "static/media/image-card-1.dab8ad44.png";